/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 30/09/15
 *   Time: 11:01
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class AssetLoadingSpeedTrackingEvent extends BasicTrackingEvent {
    //		added by the TrackingService:
    //		eventId
    //		gameId
    //		networkId
    //		accountId
    //		instanceId
    //		zoneId
    //		lang

    public playerId: number;
    public date: number;
    public accountHash: string;
    public deviceId: number;
    public storeId: number;
    public connectionType: string;
    public loadingSpeed: number;
    public assetsSize: number;
    public assetsAmount: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};

        vars.playerId = this.playerId;
        vars.date = this.date;
        vars.accountHash = this.accountHash;
        vars.deviceId = this.deviceId;
        vars.storeId = this.storeId;
        vars.connectionType = this.connectionType;
        vars.loadingSpeed = this.loadingSpeed;
        vars.assetsSize = this.assetsSize;
        vars.assetsAmount = this.assetsAmount;

        return vars;
    }
}
